import React from 'react';
import { Icon } from 'sos-common/js/components/Icon/icon';
import {
  ISbgPastApplicationsListProps,
  ISbgPastApplicationsListState,
  ISbgPastApplicationsListItem,
} from './SbgPastApplicationsList.types';

/**
 * Lists all past applications. Two different states (show all or show three)
 * The data is sent to the component in one piece but the user must click on the load more button to see more.
 */
export class SbgPastApplicationsList extends React.Component<
  ISbgPastApplicationsListProps,
  ISbgPastApplicationsListState
> {
  constructor(props: ISbgPastApplicationsListProps) {
    super(props);

    this.state = {
      showAllPosts: false,
    };
  }
  onLoadMoreClick = (e: React.MouseEvent<HTMLInputElement>) => {
    e.preventDefault();

    const { showAllPosts } = this.state;

    this.setState({
      showAllPosts: !showAllPosts,
    });
  };

  private _renderListItem(item: ISbgPastApplicationsListItem, index: number) {
    return (
      <div key={index} className="formlist-item">
        <div className="formlist-item__primary">
          <h3>{item.publicName}</h3>
        </div>
        <div className="formlist-item__secondary">
          <div className="formlist-item__buttonwrapper">
            <div className="formlist-item__linkwrapper">
              <a href={item.redirectLink}>
                {item.linkActionText}
                <Icon iconType="baseline-arrow_back-24px" />
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }

  render(): React.ReactNode {
    const { pastApplications, noSbgText } = this.props;
    const { showAllPosts } = this.state;
    const toRender = showAllPosts ? pastApplications : pastApplications.slice(0, 3);
    const showLoadMoreBtn = pastApplications.length > 3;
    const buttonText = showAllPosts ? 'Visa färre tidigare ansökningar' : 'Visa alla tidigare ansökningar';
    return (
      <div>
        <div role="log" aria-atomic="false">
          {toRender.length < 1 ? <i>{noSbgText}</i> : toRender.map((item, i) => this._renderListItem(item, i))}
        </div>
        {showLoadMoreBtn && (
          <input className={`button button--white`} type="button" value={buttonText} onClick={this.onLoadMoreClick} />
        )}
      </div>
    );
  }
}
